// extracted by mini-css-extract-plugin
export var attachment = "_rw-a";
export var emailContainer = "_rw-4";
export var emailContentPaddedContainer = "_rw-b";
export var emailHeader = "_rw-6";
export var emailIframe = "_rw-3";
export var emailInfoIcon = "_rw-9";
export var emailShortenedSummary = "_rw-e";
export var infoDropdown = "_rw-0";
export var infoRowBoundedContent = "_rw-d";
export var internal = "_rw-5";
export var merchant = "_rw-8";
export var messageInputContainer = "_rw-h";
export var normal = "_rw-7";
export var replyCard = "_rw-f";
export var subtleButton = "_rw-1";
export var subtleButtonIconContainer = "_rw-2";
export var toggleViewRepliesButton = "_rw-c";
export var wrappingText = "_rw-g";